module.exports = __webpack_public_path__ + "static/facebook-88275115ae4f0b2febda5a7f8121d9b8.jpg";